import React, { Component } from "react";
import { Pagination, AutoComplete, Tooltip } from "antd";
import moment from "moment";
import { Spin } from "antd";
import { multipleUnits } from "../../../../schema/dashboard";
import DateRange from "../../../../components/FormComponent/DateRange";
import Select2 from "../../../../components/FormComponent/select2";
import postService from "../../../../services/httpService";
import networkList from "../../../../constants/networkList";
import localStore from "../../../../services/local-store";
import { none } from "ramda";

import "./patients.css";

const $ = require("jquery");
class PatientList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      visible: false,
      dateTo: "",
      dateFrom: "",
      activePage: 1,
      totalItemsCount: 0,
      isLoading: false,
      downloadStatus: 0,
      thead: [],
      tbody: [],
      formData: "",
      appTime: [],
      headding: null,
      postdata: {},
      reportData: [],
      reportHead: [],
      selectedFilter: "",
      search_key: '',
      filteredData: [],
      filterData: [],
      showAutoComplete:true,
    };
    this.searchClick = this.searchClick.bind(this);
  }

  componentDidMount() {
    let { slug } = this.props.match.params;
    this.loadPage();

    let unitsSchema = Object.assign({}, multipleUnits);
   

    unitsSchema["feilds"].map((feild, key) => {
      if (feild.name === "unit_dashboard") {
        unitsSchema["feilds"][key]["disable"] = true;
        unitsSchema["feilds"][key]["visible"] = false;

        // unitsSchema["feilds"][key]["value"] = null;
        // unitsSchema["feilds"][key]["valid"] = false;
        // unitsSchema["feilds"][key]["errors"] = [];
        // delete unitsSchema["feilds"][key]["text"];
      }
      if (feild.name === "dashboardFilters") {
        unitsSchema["feilds"][key]["visible"] = true;
      }
      if (feild.name === "date") {
        this.setState({
          dateFrom: unitsSchema["feilds"][key]["value"] ? unitsSchema["feilds"][key]["value"][0] : moment(),
          dateTo: unitsSchema["feilds"][key]["value"] ? unitsSchema["feilds"][key]["value"][1] : moment(),
        });
      }
    });
    this.setState({ formData: unitsSchema["feilds"] }, () => {
      // this.clearFilter();
    });
  }

  itemRender(current, type, originalElement) {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  }

  componentDidUpdate(prevProps, prevState) {
    let { id, slug } = this.props.match.params;
    try {
      let { id, slug } = this.props.match.params;
      let { menuList } = this.props;
      let formSchema;
      let prevSlug = prevProps.match.params.slug;
      if (slug !== prevSlug || prevState.tbody !== this.state.tbody) {
        menuList.map((menu) => {
          if (slug !== undefined && slug !== null && slug !== "") {
            if (menu["route"] === id) {
              menu["submenu"].map((smenu) => {
                if (smenu["route"] === slug) {
                  this.setState((state) => ({
                    showAdd: JSON.parse(smenu["permissions"]["add"]),
                    showEdit: JSON.parse(smenu["permissions"]["edit"]),
                  }));
                }
              });
            }
          }
        });

        formSchema = Object.assign({}, multipleUnits);
        // formSchema["feilds"].map((feild, key) => {
        //   formSchema["feilds"][key]["value"] = null;
        //   formSchema["feilds"][key]["valid"] = false;
        //   formSchema["feilds"][key]["errors"] = [];

        //   delete formSchema["feilds"][key]["text"];
        // });
        this.setState(
          (state) => ({
            loadding: true,
            formData: formSchema["feilds"],
          }),
          () => {
            // this.clearFilter();
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    $("footer").css({ position: "relative", top: "unset" });
  }

  loadPage(search_key) {
    let { slug, id } = this.props.match.params;
    const params = new URLSearchParams(this.props.location.search);
    let report_type = params.get("from");
  
    if (report_type === "opd-consultation") {
      report_type = "OPD Consultation"
    } else if (report_type === "billing") {
      report_type = "Billing"
    } else if (report_type === "radiology") {
      report_type = "Radiology"
    }

    const { DashboardDetailsInfoByBiller, DashboardDetailsInfoByDepartment } =
      networkList;
    let tableHead = [],
      billingTableHead = [];
    let data = [];
    let This = this;
    let userData = localStorage.getItem("user_data");
    if (userData !== undefined && userData !== null && userData !== "") {
      userData = JSON.parse(userData);
    }
    // switch (slug) {
    //   case "dashboard-details":
    tableHead = [
      { key: "name", label: "Patient Name" },
      { key: "umr", label: "UMR" },
      { key: "billnumber", label: "Bill Number" },
      { key: "casetype", label: "Patient Type" },
      { key: "unitname", label: "Unit Name" },
      { key: "age", label: "Age" },
      { key: "gender", label: "Gender" },
      { key: "phonenumber", label: "Phone Number" },
      { key: "appointment_date", label: "Appointment Date" },
      { key: "appointment_id", label: "Appointment Id" },
      { key: "departmentname", label: "Department" },
      { key: "service_group_name", label: "Service Group" },
      { key: "service_name", label: "Service Name" },
      {
        key: "room_number",
        label: "Room Number",
      },
      { key: "arrivaltime", label: "Arrival Time" },
      { key: "vitals_time", label: "Vitals Time" },
      { key: "checkin_time", label: "Checkin Time" },
      { key: "checkout_time", label: "Checkout Time" },
      { key: "WaitingTAT1", label: "Waiting TAT 1" },
      { key: "WaitingTAT2", label: "Waiting TAT 2" },
      { key: "ProceduralTAT", label: "Procedural TAT" },
      { key: "billing_time", label: "Billing Time" },
      { key: "bill_done_by", label: "Bill Done By" },
      { key: "bill_cancel_status", label: "Bill Cancel Status" },
      { key: "bill_cancel_date", label: "Bill Cancel Date" },
      { key: "created_at", label: "Created At" },
      { key: "service_name", label: "Billed_Doctor" },
      { key: "served_doctor_name", label: "Served_Doctor" },
      {
        key: "latest_skip_reason",
        label: "Latest Skip Reason",
      },
    ];
    billingTableHead = [
      { key: "patient_name", label: "Patient Name" },
      { key: "umr", label: "UMR" },
      { key: "ip", label: "IP" },
      { key: "service", label: "Service" },
      { key: "skip_count", label: "Skip Count" },
      { key: "token_issue_date", label: "Token Issue Date" },
      { key: "token_status", label: "Token Status" },
      { key: "phone_number", label: "Phone Number" },
      { key: "age", label: "Age" },
      { key: "gender", label: "Gender" },
      { key: "unit_name", label: "Unit Name" },
      { key: "work_station_name", label: "work Station Name" },
      { key: "checkin_time", label: "Checkin Time" },
      { key: "checkout_time", label: "Checkout Time" },
      { key: "created_at", label: "Created At" },
      { key: "TAT", label: "TAT" },
    ];
    // this.setState({
    //   thead: tableHead,
    this.setState(
      (state) => ({
        // tableTitle: "Table title",
        // thead: tableHead,
        showFilter: search_key ? true : false,
        //showAutoComplete : false,
        
      }),
      () => {
        let payload = {
          data: {
            unit_id: null,
            from_date: null,
            to_date: null,
            report_type: null, //  Radiology,OPD Consultation
            filters: null, //1- Total Patients,2- Planned Visits,3- Un-Planned Visits,4- Serviced,5- Waiting,6- No-Shows,7- Total Skips
            page: this.state.activePage,
            "page_no": this.state.activePage,
            "search_key": search_key ? search_key : '',
          },

        };
      
        var formFeilds = this.state.formData;
        var selectedFilter = this.state.selectedFilter;
        formFeilds.map((field) => {
          if (field["name"] === "unit_dashboard") {
            let current_Unit = localStore.get("current_Unit");
            let current_Unit_Details = current_Unit && JSON.parse(current_Unit);
            // payload["data"]["unit_id"] = field.value && field.value;
            payload["data"]["unit_id"] = current_Unit_Details ? current_Unit_Details.unit_id : userData ? userData.unitid : null
          }
         if (field["name"] === "date") {
            payload["data"]["from_date"] =
              field.value && moment(field.value[0]).format("YYYY-MM-DD");
            payload["data"]["to_date"] =
              field.value && moment(field.value[1]).format("YYYY-MM-DD");
          }
          if (field["name"] === "reporttype") {
            payload["data"]["report_type"] = field.value ? field.value : report_type ? report_type : null;
          } else {
            payload["data"]["filters"] = selectedFilter
              ? selectedFilter
              : field.value && field.value;
          }
        });
     
        payload && payload["data"]["report_type"] === "Billing"
          ? this.setState({ thead: billingTableHead , showAutoComplete:false })
          : this.setState({ thead: tableHead });
        this.setState({ isLoading: true });
        // if (payload && payload["data"]["report_type"] === "Radiology") {
        //   this.setState({
        //     showAutoComplete: false, 
        //   });

        if (payload && payload["data"]["report_type"] === "Billing") {
          postService(DashboardDetailsInfoByBiller, "POST", payload).then(
            (res) => {
              this.setState({ isLoading: false });
              if (res.status) {
                this.setState((state) => ({
                  tbody: res.data,
                  totalItemsCount: res.total_items,
                }));
              }
            }
          );
        } else {
          postService(DashboardDetailsInfoByDepartment, "POST", payload).then(
            (res) => {
              this.setState({ isLoading: false });
              if (res.status) {
                this.setState((state) => ({
                  tbody: res.data,
                  totalItemsCount: res.total_items,
                }));
              }
            }
          );
        }
        if(payload && payload["data"]["report_type"] === "Radiology"){
          this.setState({ showAutoComplete:false })
        }
      }

    );
    //     break;
    //   default:
    //     break;
    // }
  }
  // loadPage = (search_key) => {
  //   try {
  //     let { slug, id } = this.props.match.params;
  //     let { activePage, search_key } = this.state;
  //     const params = new URLSearchParams(this.props.location.search);
  //     let report_type = params.get("from");
  //     if (report_type === "opd-consultation") {
  //       report_type = "OPD Consultation"
  //     } else if (report_type === "billing") {
  //       report_type = "Billing"
  //     } else if (report_type === "radiology") {
  //       report_type = "Radiology"
  //     }

  //     const { DashboardDetailsInfoByBiller, DashboardDetailsInfoByDepartment } =
  //       networkList;
  //     let tableHead = [],
  //       billingTableHead = [];
  //     let data = [];
  //     let This = this;
  //     let userData = localStorage.getItem("user_data");
  //     if (userData !== undefined && userData !== null && userData !== "") {
  //       userData = JSON.parse(userData);
  //     }
  //     // switch (slug) {
  //     //   case "dashboard-details":
  //     tableHead = [
  //       { key: "name", label: "Patient Name" },
  //       { key: "umr", label: "UMR" },
  //       { key: "billnumber", label: "Bill Number" },
  //       { key: "casetype", label: "Patient Type" },
  //       { key: "unitname", label: "Unit Name" },
  //       { key: "age", label: "Age" },
  //       { key: "gender", label: "Gender" },
  //       { key: "phonenumber", label: "Phone Number" },
  //       { key: "appointment_date", label: "Appointment Date" },
  //       { key: "appointment_id", label: "Appointment Id" },
  //       { key: "departmentname", label: "Department" },
  //       { key: "service_group_name", label: "Service Group" },
  //       { key: "service_name", label: "Service Name" },
  //       {
  //         key: "room_number",
  //         label: "Room Number",
  //       },
  //       { key: "arrivaltime", label: "Arrival Time" },
  //       { key: "checkin_time", label: "Checkin Time" },
  //       { key: "checkout_time", label: "Checkout Time" },
  //       { key: "WaitingTAT", label: "Waiting TAT" },
  //       { key: "ProceduralTAT", label: "Procedural TAT" },
  //       { key: "billing_time", label: "Billing Time" },
  //       { key: "bill_done_by", label: "Bill Done By" },
  //       { key: "bill_cancel_status", label: "Bill Cancel Status" },
  //       { key: "bill_cancel_date", label: "Bill Cancel Date" },
  //       { key: "created_at", label: "Created At" },
  //       { key: "doctor_name", label: "Doctor Name" },
  //       {
  //         key: "latest_skip_reason",
  //         label: "Latest Skip Reason",
  //       },
  //     ];
  //     billingTableHead = [
  //       { key: "patient_name", label: "Patient Name" },
  //       { key: "umr", label: "UMR" },
  //       { key: "ip", label: "IP" },
  //       { key: "service", label: "Service" },
  //       { key: "skip_count", label: "Skip Count" },
  //       { key: "token_issue_date", label: "Token Issue Date" },
  //       { key: "token_status", label: "Token Status" },
  //       { key: "phone_number", label: "Phone Number" },
  //       { key: "age", label: "Age" },
  //       { key: "gender", label: "Gender" },
  //       { key: "unit_name", label: "Unit Name" },
  //       { key: "work_station_name", label: "work Station Name" },
  //       { key: "checkin_time", label: "Checkin Time" },
  //       { key: "checkout_time", label: "Checkout Time" },
  //       { key: "created_at", label: "Created At" },
  //       { key: "TAT", label: "TAT" },
  //     ];
  //     // this.setState({
  //     //   thead: tableHead,
  //     this.setState(
  //       (state) => ({
  //         // tableTitle: "Table title",
  //         // thead: tableHead,
  //         showFilter: search_key ? true : false,
  //         tbody: [],
  //       }),
  //       () => {
  //         let payload = {
  //           data: {
  //             unit_id: null,
  //             from_date: null,
  //             to_date: null,
  //             report_type: null, //  Radiology,OPD Consultation
  //             filters: null, //1- Total Patients,2- Planned Visits,3- Un-Planned Visits,4- Serviced,5- Waiting,6- No-Shows,7- Total Skips
  //             page: this.state.activePage,
  //           },
  //           "page_no": this.state.activePage,
  //           "search_key":search_key?search_key:'',
  //         };
  //         var formFeilds = this.state.formData;
  //         var selectedFilter = this.state.selectedFilter;
  //         formFeilds.map((field) => {
  //           if (field["name"] === "unit_dashboard") {
  //             let current_Unit = localStore.get("current_Unit");
  //             let current_Unit_Details = current_Unit && JSON.parse(current_Unit);
  //             // payload["data"]["unit_id"] = field.value && field.value;
  //             payload["data"]["unit_id"] = current_Unit_Details ? current_Unit_Details.unit_id : userData ? userData.unitid : null
  //           }
  //           if (field["name"] === "date") {
  //             payload["data"]["from_date"] =
  //               field.value && moment(field.value[0]).format("YYYY-MM-DD");
  //             payload["data"]["to_date"] =
  //               field.value && moment(field.value[1]).format("YYYY-MM-DD");
  //           }
  //           if (field["name"] === "reporttype") {
  //             payload["data"]["report_type"] = field.value ? field.value : report_type ? report_type : null;
  //           } else {
  //             payload["data"]["filters"] = selectedFilter
  //               ? selectedFilter
  //               : field.value && field.value;
  //           }
  //         });
  
  //         payload && payload["data"]["report_type"] === "Billing"
  //           ? this.setState({ thead: billingTableHead })
  //           : this.setState({ thead: tableHead });

  //         this.setState({ isLoading: true });

  //         if (payload && payload["data"]["report_type"] === "Billing") {
  //           postService(DashboardDetailsInfoByBiller, "POST", { data: payload }).then(
  //             (res) => {
  //               this.setState({ isLoading: false });
  //               if (res.status) {
  //                 this.setState((state) => ({
  //                   tbody: res.data,
  //                   totalItemsCount: res.total_items,
  //                   showFilter: true,
  //                   data: data,
  //                 }));
  //               }
  //             }
  //           );
  //         } else {
  //           postService(DashboardDetailsInfoByDepartment, "POST", payload).then(
  //             (res) => {
  //               this.setState({ isLoading: false });
  //               if (res.status) {
  //                 this.setState((state) => ({
  //                   tbody: res.data,
  //                   totalItemsCount: res.total_items,
  //                   showFilter: true,
  //                 }));
  //               }
  //             }
  //           );
  //         }
  //       }
  //     );
  //     //     break;
  //     //   default:
  //     //     break;
  //     // }
  //   }
  //   catch (error) {
  //     // Handle the error here
  //     console.error(error);
  //   }
  // }
  handleChange(ele) {
   var formFeilds = this.state.formData;
    if (ele) {
      if (formFeilds) {
        if (ele.name === "date") {
          formFeilds[1]["value"] = ele.value;
          formFeilds[1]["text"] = ele.value;
          this.setState({
            dateFrom: ele.value[0],
            dateTo: ele.value[1],
            activePage: 1,
            totalItemsCount: 0,
          });
        } else {
          formFeilds[2]["value"] = ele.value;
          this.setState({
            formData: formFeilds,
            selectedFilter: ele.value,
            activePage: 1,
            totalItemsCount: 0,
          });
        }
      }
    }
    // this.fetchData();
    this.loadPage();
  }

  fetchData() {
    const { DashboardData } = networkList;
    const { dateTo, dateFrom, formData } = this.state;
    const obj = {
      unit_id:
        formData && formData[0] && formData[0].value && formData[0].value,
      from_date:
        formData && formData[1]
          ? formData[1].value &&
          formData[1].value[0] &&
          moment(formData[1].value[0]).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      to_date:
        formData && formData[1]
          ? formData[1].value &&
          formData[1].value[1] &&
          moment(formData[1].value[1]).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
    };
    this.setState({ isLoading: true });

    postService(DashboardData, "POST", { data: obj }).then((res) => {
      if (res) {
        this.setState({ isLoading: false });
        if (res.status) {
          this.setState({ data: res.data });
        }
      }
    });
  }
  handlePageChange(page) {
  
    this.setState(
      (state) => ({
        // tbody: [],
        activePage: page,
      }),
      () => {
        this.loadPage();
      }
    );
    // this.setState({ activePage: page });
  }
  handleKeydown = (event) => {
    if (event.key === 'Enter') { // Use 'key' instead of 'keys'
      this.searchClick();
    }
  }
  searchClick() {
    let { search_key } = this.state;
    this.setState({ activePage: 1 }, () => {

      this.loadPage(search_key);
    });
  }
  render() {
    let { tableTitle, thead, tbody, formData, activePage, search_key, showAutoComplete ,  totalItemsCount , handleKeydown} =
      this.state;

    return (
      <div className="DashboardView">
        <div className="clearfix">
          <div className="float-left pt-2 title-Text">{tableTitle}</div>
        </div>
        <Spin spinning={this.state.isLoading}>
          <div className="mr-3 clearfix">
            <div className="row">
              {formData &&
                formData.length > 0 &&
                formData.map((feild, key) => {
                  // eslint-disable-next-line no-lone-blocks
                  {
                    if (feild.element === "select2" && feild.visible) {
                      return (
                        <div className="col-3 pl-0 , table-card">
                          <div
                            className={`${feild.className ? feild.className : "col"
                              } ${feild.name}`}
                            key={key}
                            >
                            <Select2
                              selectdata={feild}
                              // changedObj={this.state.changedObj}
                              {...this.props}
                              {...this.state}
                              // Queuedata={this.state.formData}
                              onselectChanges={this.handleChange.bind(this)}
                            />
                            {showAutoComplete  && (
                              <div >
                                <AutoComplete
                                  style={{
                                    width: '417px', // Set your desired width for AutoComplete
                                    left: "300px",
                                    bottom: "31px",
                                    borderRadius: "10px",
                                    border: "none",
                                    boxShadow: "0px 1px 8px rgba(23, 110, 222, 0.1)",
                                    
                                  }}
                                  placeholder="Search by Patient Name , UMR , Bill Number , Phone Number , Department "
                                  value={search_key}
                                  onChange={(value) => this.setState({ search_key: value })}
                                  onInputKeyDown={this.handleKeydown} 
                                  
                                />
                                <div style={{
                                  position: "relative",
                                  left: "730px",
                                  bottom: "62px"
                                }}>
                                  <button className="btn btn-success btn-sm p-1" type="button" onClick={this.searchClick.bind(this)}>
                                    <img src="/assets/images/icons/search.png" alt="Search" />
                                  </button>
                                </div>
                              </div>
                            )}

                          </div>
                        </div>
                      );
                    }
                    if (feild.element === "daterange") {
                      return (
                        <div
                        style={{height:"50%"}}
                          className={`${feild.className ? feild.className : "col "
                            } ${feild.name}`}
                          key={key}
                        >
                          {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                            
                          <DateRange
                            Queuedata={formData}
                            selectdata={feild}
                            {...this.props}
                            {...this.state}
                            // onselectChanges={this.handleChange.bind(this)}
                            onselectChanges={(e) => {
                            
                              this.handleChange(e);
                              this.setState({
                                dateFrom: e.value[0],
                                dateTo: e.value[1],
                              });
                            }}
                          />
                        </div>
                      );
                    }
                  }
                })}
            </div>
          </div>
          <div className="card mt-2 mb-3 card-table table-card">
            <div
              className="financial-table table-responsive sticky-header"
              id="table"
            >
              <table className="table table-hover table-bordered mb-0 bg-white">
                <thead>
                  <tr>
                    <td className="text-capitalize align-middle">S.No.</td>
                    {thead.map((head, key) => {
                      // return (
                      //   <td className="text-capitalize align-middle" key={key}>
                      //     {head["label"]}
                      //   </td>
                      // );
                      return (
                        head["label"]=="Vitals Time"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title="Vitals Captured Time" color='#6c3964'>
                        
                            {head["label"]}
                        
                        </Tooltip></td>)
                        : head["label"]=="Waiting TAT 1"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title="Arrival Time to Vitals Time" color='#6c3964'>
                        
                        {head["label"]}
                    
                    </Tooltip></td>)
                    :head["label"]=="Waiting TAT 2"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title = 
                    {
                      <div style={{ textAlign: 'center' }}>
                      Vitals Time to Checkin Time<br />
                      <span style={{ display: 'block' }}>or</span>
                      Arrival Time to Checkin Time
                    </div>
                } color='#6c3964'>
                        
                    {head["label"]}
                
                </Tooltip></td>)
                :head["label"]=="Procedural TAT"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title=" Checkin Time to Checkout Time" color='#6c3964'>
                        
                {head["label"]}
            
            </Tooltip></td>)
            :
                        ( <td className="text-capitalize align-middle" key={key}>
                          {head["label"]}
                        </td>)
                       
                       
                      );
                    })}
                  </tr>
                </thead>
                {tbody != "" ? (
                  <tbody>
                    {tbody.map((body, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {key +
                              1 +
                              (activePage > 1
                                ? 20 * (activePage > 2 ? activePage - 1 : 1)
                                : 0)}
                          </td>
                          {thead.map((head, Hkey) => {
                            if (head["key"] === "created_at") {
                              return (
                                <td>
                                  {body["created_at"]
                                    ? moment(body["created_at"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "checkin_time") {
                              return (
                                <td>
                                  {body["checkin_time"]
                                    ? moment(body["checkin_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "vitals_time") {
                              return (
                                <td>
                                  {body["vitals_time"]
                                    ? moment(body["vitals_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "checkout_time") {
                              return (
                                <td>
                                  {body["checkout_time"]
                                    ? moment(body["checkout_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "date") {
                              return (
                                <td>
                                  {body["date"]
                                    ? moment(body["date"]).format("DD-MM-YYYY")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["type"] === "date") {
                              let new_date =
                                body[head["key"]] && body[head["key"]] !== ""
                                  ? body[head["key"]]
                                  : null;
                              return (
                                <td>
                                  {new_date
                                    ? moment(new_date).format("DD-MM-YYYY ")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "avg_tat") {
                              return (
                                <td>
                                  {body["avg_tat"] && body["avg_tat"] !== ""
                                    ? Number.isInteger(body["avg_tat"])
                                      ? body["avg_tat"]
                                      : body["avg_tat"].toFixed(2)
                                    : "NA"}
                                </td>
                              );
                            }

                            return (
                              <td className="text-capitalize">
                                {body[head["key"]] ? body[head["key"]] : "NA"}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="13" className="text-center">
                        <img src="/assets/images/icons/no-data.svg" alt="" />
                        <p className="no-data mb-0">No Data</p>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <div className="row justify-content-center align-item-center mx-0">
            <div className="col pagenation-col mb-3" >
              <Pagination
                current={this.state.activePage}
                total={totalItemsCount}
                itemRender={this.itemRender.bind(this)}
                pageSize={20}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

export default PatientList;
